<div
  *ngIf="isOpen"
  class="agent-doc-preview-overlay"
  role="presentation"
  (click)="onBackdropClick($event)"
  (keydown.escape)="close()"
>
  <div
    class="agent-doc-preview-modal"
    role="dialog"
    aria-modal="true"
    aria-label="Document Preview"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <header class="agent-doc-preview-modal__header">
      <h2 class="agent-doc-preview-modal__title">Document Preview</h2>
      <div class="agent-doc-preview-modal__toolbar">
        <button
          type="button"
          class="agent-doc-preview-modal__icon-btn"
          (click)="zoomOut()"
          [disabled]="zoomLevel <= 50 || isLoading"
          aria-label="Zoom out"
        >
          <img
            src="assets/icons/zoom-out.svg"
            alt=""
            class="agent-doc-preview-modal__toolbar-icon"
            aria-hidden="true"
          />
        </button>
        <span class="agent-doc-preview-modal__zoom-level">{{ zoomLevel }}%</span>
        <button
          type="button"
          class="agent-doc-preview-modal__icon-btn"
          (click)="zoomIn()"
          [disabled]="zoomLevel >= 200 || isLoading"
          aria-label="Zoom in"
        >
          <img
            src="assets/icons/zoom-in.svg"
            alt=""
            class="agent-doc-preview-modal__toolbar-icon"
            aria-hidden="true"
          />
        </button>
        <button
          type="button"
          class="agent-doc-preview-modal__icon-btn"
          (click)="downloadFile()"
          [disabled]="isLoading"
          aria-label="Download"
        >
          <span
            class="agent-doc-preview-modal__toolbar-icon agent-doc-preview-modal__toolbar-icon--download"
            aria-hidden="true"
          ></span>
        </button>
        <button
          type="button"
          class="agent-doc-preview-modal__icon-btn"
          (click)="openInNewTab()"
          [disabled]="!canOpenInNewTab"
          aria-label="Open in new tab"
        >
          <i class="fa-solid fa-up-right-from-square" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="agent-doc-preview-modal__icon-btn agent-doc-preview-modal__close-btn"
          (click)="close()"
          aria-label="Close"
        >
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      </div>
    </header>

    <main class="agent-doc-preview-modal__content">
      <div *ngIf="isLoading" class="agent-doc-preview-modal__loading" role="status">
        <div class="agent-doc-preview-modal__spinner"></div>
        <p>Loading document preview...</p>
      </div>

      <div *ngIf="errorMessage && !isLoading" class="agent-doc-preview-modal__error" role="alert">
        <p>{{ errorMessage }}</p>
      </div>

      <div *ngIf="!isLoading && !errorMessage && showPdfViewer && pdfSrc" class="agent-doc-preview-modal__pdf-wrap">
        <pdf-viewer
          [src]="pdfSrc"
          [render-text]="true"
          [original-size]="false"
          [zoom]="pdfZoom"
          [zoom-scale]="'page-width'"
          [show-all]="true"
          [stick-to-page]="false"
          [external-link-target]="'blank'"
          [autoresize]="true"
          [fit-to-page]="false"
          (after-load-complete)="onPdfLoadComplete($event)"
          (page-rendered)="onPageRendered()"
          (error)="onPdfError($event)"
          class="agent-doc-preview-modal__pdf-viewer"
        ></pdf-viewer>
      </div>
    </main>

    <footer class="agent-doc-preview-modal__footer">
      <button
        type="button"
        class="agent-doc-preview-modal__open-tab-btn"
        (click)="openInNewTab()"
        [disabled]="!canOpenInNewTab"
      >
        <i class="fa-solid fa-up-right-from-square" aria-hidden="true"></i>
        Open In New Tab
      </button>
    </footer>
  </div>
</div>
